import React from 'react';
import { DashboardProvider } from '@warehouse/quickbase';
import { DashboardQuickbase } from './Dashboard';

export function Dashboard() {
	return (
		<DashboardProvider>
			<DashboardQuickbase />
		</DashboardProvider>
	);
}
